import { motion } from 'framer-motion';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppointmentBooking } from '../Appointments';

import { useCheckoutContext } from '../../providers';
import { setAppointmentBookingData } from '../../features/ui/uiSlice';

function RequiredConsultBooking({ onAppointmentBooked }) {
    const dispatch = useDispatch();
    const [screen, setScreen] = useState('interstitial'); //'interstitial', 'booking'

    const { setCheckoutStep, skipInsurance } = useCheckoutContext();
    const { hstInCart, lowScoreConsultRequired, stateRequiredTelehealth } = useSelector(
        (state) => state.cart,
    );

    return (
        <>
            {screen === 'interstitial' && (
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                    <div className="layout-outlet-root space-y-5 max-w-2xl">
                        <h5 className="font-heading text-4xl font-bold lg:text-5xl">
                            Next Up: Schedule a quick virtual visit.
                        </h5>
                        <p className="text-sm lg:text-base">
                            {hstInCart
                                ? 'A virtual visit is needed before we can ship your home sleep study. During your visit, our providers will review your medical history and confirm the next steps.'
                                : 'You are required to schedule a virtual visit before you can receive your purchase from GEM. During your visit, our providers will review your medical history and confirm the next steps.'}
                        </p>
                        <button
                            className="btn-primary w-full"
                            onClick={() => {
                                setScreen('booking');
                                dispatch(
                                    setAppointmentBookingData({
                                        key: 'appointmentToReschedule',
                                        value: null,
                                    }),
                                );
                            }}>
                            SCHEDULE VIRTUAL VISIT
                        </button>
                        {!(stateRequiredTelehealth || lowScoreConsultRequired) && (
                            <>
                                <hr className="my-4" />
                                <button
                                    className="btn-shell w-full"
                                    onClick={() => skipInsurance()}>
                                    continue without insurance
                                </button>
                                <h6 className="mb-5 text-center font-heading text-gem-green text-xl font-bold lg:text-2xl">
                                    No Virtual Visit Required
                                </h6>
                            </>
                        )}
                    </div>
                </motion.div>
            )}
            {screen === 'booking' && (
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                    <AppointmentBooking
                        onAppointmentBooked={() => {
                            if (onAppointmentBooked) {
                                onAppointmentBooked();
                            }
                            setCheckoutStep('consult-confirmation');
                        }}
                    />
                </motion.div>
            )}
        </>
    );
}

export default RequiredConsultBooking;
